<template>
  <view-wrapper
    :show-back-button="true"
    :name="this.title"
    :path="'labels/' + this.$route.params.labelId"
    back-text="Back to label overview"
    :loading="loading"
    loading-text="Loading QualityAssuranceLabelDetails"
  >
    <div class="float-right font-semibold">
      <span v-if="!!message">
        {{ message }}
      </span>
    </div>

    <AuthorizationZone
      allowAny="QualityAssuranceRole:LabelDesigner,AccountType:Administrator,UserRole:LabelManager"
    >
      <div class="mb-3">
        <grafokett-button
          :disabled="isLocked"
          class="big ml-2 bg-primary text-textcolor"
          @click="checkoutLabel()"
          >Checkout for editing
          <span v-if="isLocked" class="lock-symbol" :class="'locked'"
            ><i /></span
        ></grafokett-button>
        <grafokett-button
          :disabled="!isLocked"
          class="big ml-2 bg-primary text-textcolor"
          @click="uploadAndPreviewLabel()"
          >Upload and preview new version
          <span v-if="!isLocked" class="lock-symbol" :class="'locked'"
            ><i /></span
        ></grafokett-button>
      </div>
    </AuthorizationZone>

    <wrapper class="mb-3 ml-2 p-5" v-if="isLocked">
      <div class="mb-3" v-if="isLocked && lockedLabelData.lockedUntil">
        <p>
          Locked by {{ lockedLabelData.lockedBy }} until
          {{ lockedLabelData.lockedUntil.slice(0, 16) }}
        </p>
      </div>
    </wrapper>

    <wrapper class="mb-3 ml-2 p-5 overflow-y-hidden">
      <h2>Info</h2>
      <hr />

      <img
        @click="showModal = true"
        style="float:right; max-width: 200px; max-height: 300px;"
        v-if="previewData"
        :src="previewData"
      />

      <modal
        v-if="showModal"
        @modalMaskClicked="showModal = false"
        class="overflow-y-auto"
        hideHeader="true"
      >
        <template slot="body">
          <div
            style="max-width: 1000px; max-height: 900px;"
            class="relative flex justify-center bg-primary-light p-4"
          >
            <img class="block object-contain" :src="previewData" alt="label" />
          </div>
        </template>
      </modal>

      <div class="p-2">
        <h3>Variables</h3>
        <div v-if="currentLabel && currentLabel.variables">
          <div
            v-for="(variable, variableIndex) in currentLabel.variables"
            :key="variableIndex"
          >
            {{ variable.name }}
          </div>
        </div>
      </div>
    </wrapper>

    <wrapper class="mb-3 ml-2 p-5">
      <h2>Test article</h2>
      <div v-if="lockedLabelData && lockedLabelData.testArticle" class="p-2">
        <h3>{{ lockedLabelData.testArticle.name }}</h3>
        <div v-if="lockedLabelData.testArticle.articleData">
          <div
            v-for="(testArticleData, testArticleDataIndex) in lockedLabelData
              .testArticle.articleData"
            :key="testArticleDataIndex"
          >
            <span class="text-sm">
              <b>{{ testArticleData.key }}:</b> {{ testArticleData.data }}
            </span>
          </div>
        </div>
      </div>
      <hr />
      <grafokett-input
        labelPlaceholder="Search for test article"
        v-model="testArticleQuery"
        @input="onSearch($event)"
      />
      <div v-if="testArticleResult">
        <div
          v-for="(testArticle, testArticleResultIndex) in testArticleResult"
          :key="testArticleResultIndex"
        >
          <a @click="setTestArticle(testArticle)" class="button small">
            <span class="text-sm">
              {{ testArticle.name }}
            </span>
          </a>
        </div>
      </div>
    </wrapper>

    <wrapper class="mb-3 ml-2 p-5">
      <div class="p-2">
        <h2 class="ml-3">Versions</h2>
      </div>
      <div>
        <div
          v-if="
            lockedLabelData &&
              lockedLabelData.versions &&
              lockedLabelData.versions.length > 0
          "
          class="p-5"
        >
          <div
            v-for="(version, versionIndex) in lockedLabelData.versions"
            :key="versionIndex"
          >
            <hr />
            <h3 class="ml-3">Version {{ version.labelVersionId }}</h3>
            <div class="text-right">
              <grafokett-button class="primary" @click="onPreview(version)">
                {{ activePreview === version.labelVersionId ? "Hide" : "Show" }}
                details
              </grafokett-button>
            </div>

            <div
              v-if="activePreview === version.labelVersionId"
              class="relative rounded shadow p-4 my-2 bg-primary-light"
            >
              <AuthorizationZone
                allowAny="QualityAssuranceRole:LabelDesigner,AccountType:Administrator,UserRole:LabelManager"
              >
                <div class="text-right">
                  <grafokett-button
                    v-if="!version.isPublished"
                    class="primary"
                    @click="
                      $router.push(
                        `/qa/labels/${labelId}/versions/${
                          version.labelVersionId
                        }/preview`
                      )
                    "
                    >Preview</grafokett-button
                  >
                  <grafokett-button
                    v-if="!version.isPublished"
                    class="primary"
                    @click="abandon(version)"
                    >Abandon</grafokett-button
                  >
                  <grafokett-button
                    v-if="version.isPublished"
                    class="primary"
                    @click="rePublish(version)"
                    >Re-publish</grafokett-button
                  >
                </div>
              </AuthorizationZone>
              <div
                class="text-right"
                v-for="(previewData, previewDataIndex) in version.previewData"
                :key="previewDataIndex"
              >
                <preview-image
                  :current-preview="previewData.right.preview"
                  @click="openPreview(previewData.right.preview)"
                />
              </div>
              <hr />
              <div
                class="flex flex-wrap w-full"
                v-for="(child, index) in version.approvals"
                :key="index"
              >
                <div
                  class="flex-auto flex flex-col text-base mt-4 p-3 rounded bg-primary-dark"
                  key="index"
                >
                  <span class="text-lg mb-2">
                    {{ formatDate(child.timestamp) }}
                  </span>
                  <span class="text-sm">
                    {{
                      `Comment: ${
                        child.comment ? child.comment : "Description not set"
                      }`
                    }}
                  </span>
                  <span class="text-sm">
                    Approved By {{ child.approverName }} with role
                    {{ child.approverRole }}
                  </span>
                  <span
                    class="text-sm"
                    v-if="child.approverRole != 'LabelDesigner'"
                  >
                    {{
                      isNaN(child.approvalStatus)
                        ? `Approver status: ${child.approvalStatus}`
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wrapper>

    <modal v-if="showPreview" type="success" @close="showPreview = false">
      <template slot="body">
        <div
          style="max-width: 800px; max-height: 600px"
          class="relative flex justify-center bg-primary-light p-4"
        >
          <img class="block object-contain" :src="currentPreview" alt="label" />
        </div>
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import { BehaviorSubject, combineLatest } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

import Modal from "../../../components/Modal";
import GrafokettButton from "../../../components/forms/Button.vue";
import GrafokettInput from "../../../components/forms/Input.vue";
import AuthorizationZone from "../../../components/AuthorizationZone";
import PreviewImage from "../../../components/PreviewImage";
import { formatDate } from "../../../utils/dateHelpers";

export default {
  components: {
    Modal,
    PreviewImage,
    GrafokettButton,
    GrafokettInput,
    AuthorizationZone
  },
  data: () => ({
    loading: false,
    message: "",
    isLocked: false,
    lockedLabelData: null,
    title: "QualityAssurance - Details",
    currentLabel: null,
    previewData: null,
    showPreview: false,
    versionData: [],
    labelVersion: null,
    testArticleQuery: null,
    searchQuery$: null,
    testArticleResult: [],
    activePreview: 0,
    showModal: false
  }),
  computed: {
    labelId() {
      return this.$route.params.labelId;
    },
    label() {
      if (this.currentLabel) {
        return [this.currentLabel];
      }
      return [];
    },
    labels() {
      return this.label.map(l => {
        return {
          id: l.labelId,
          name: l.name,
          modified: new Date(l.modified).toLocaleDateString("sv-SE"),
          expandableData: {
            variabels: l.variables.map(v => {
              return {
                name: v.name,
                description: v.propertyDescription,
                length: v.propertySize,
                IsFixedLength: v.propertySize !== 0,
                locked: !v.editable,
                boundToName: !v.boundToId
                  ? v.name
                  : l.variables.filter(e => e.id === v.boundToId)[0].name
              };
            })
          }
        };
      });
    }
  },
  methods: {
    formatDate,
    async getData() {
      this.loading = true;
      const response = await this.$store.$api.get(
        `/api/labels/${this.labelId}`
      );
      this.currentLabel = { ...response.data.data };
      await this.$store.dispatch("QUALITY_ASSURANCE/GET_PREVIEW", {
        labelId: this.labelId,
        versionId: 0
      });
      await this.getLabelInfo(this.labelId);

      this.previewData =
        "data:image/png;base64, " +
        this.$store.getters["QUALITY_ASSURANCE/PREVIEW"].design.leftPng;
      this.loading = false;
      this.title = this.currentLabel.name + " - Details";
    },
    async setLockedLabel(id) {
      const response = await this.$store.$api.post(
        `/api/QualityAssurance/lockLabel/${id}`
      );
      this.lockedLabelData = response.data;
    },
    async getLabelInfo(id) {
      const response = await this.$store.$api.get(
        `/api/QualityAssurance/getLabelInfo/${id}`
      );
      this.lockedLabelData = response.data;
      this.isLocked = !(
        this.lockedLabelData &&
        !this.lockedLabelData.lockedUntil &&
        !this.lockedLabelData.lockedBy
      );
    },
    async searchTestArticles(event) {
      if (event == "") {
        this.testArticleResult = [];
        return;
      }
      
      // Check if connector is enabled and active
      const settingsResponse = await this.$store.$api.get("/api/subscription");
      const activeConnector = settingsResponse.data.data.activeConnector;
      const connectorsEnabled = settingsResponse.data.data.connectorsEnabled;
      
      // Build API URL based on connector status
      let apiUrl;
      if (connectorsEnabled && activeConnector && activeConnector.id) {
        // Use connector endpoint when connector is active
        apiUrl = `/api/connectors/${activeConnector.id}/articles?take=10&offset=0&searchQuery=${event}`;
      } else {
        // Use regular articles endpoint
        apiUrl = `/api/articles?take=10&offset=0&searchQuery=${event}`;
      }
      
      const response = await this.$store.$api.get(apiUrl);
      this.testArticleResult = response.data.data;
    },
    async setTestArticle(a) {
      await this.$store.dispatch("QUALITY_ASSURANCE/SET_TEST_DATA_ARTICLE", {
        labelId: this.labelId,
        testArticleId: a.id
      });

      this.searchQuery$.next("");
      await this.getData();
    },
    async abandon(version) {
      this.loading = true;
      await this.$store.$api.delete(
        `/api/QualityAssurance/labels/${this.labelId}/version/${
          version.labelVersionId
        }/abandon`
      );

      await this.getData();
      this.loading = false;
    },
    async rePublish(version) {
      this.loading = true;
      var response = await this.$store.$api.post(
        `/api/QualityAssurance/labels/${this.labelId}/versions/${
          version.labelVersionId
        }/republish`
      );

      this.loading = false;
      if (response.data.versionId) {
        this.$router.push(
          `/qa/labels/${this.labelId}/versions/${
            response.data.versionId
          }/preview`
        );
      }
      await this.getData();
    },
    async downloadLabelData(labelId) {
      const response = await this.$store.$api.get(
        `/api/labels/labelData/${labelId}?binaryResponse=true`,
        {
          responseType: "blob",
          headers: {
            "Content-Disposition": `attachment; filename="download.nlbl"; filename*="download.nlbl"`
          }
        }
      );
      const fileName = (this.currentLabel.name + ".nlbl").replace(
        ".nlbl.nlbl",
        ".nlbl"
      );
      const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");
      fileLink.target = "_blank";
      fileLink.href = fileUrl;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async checkoutLabel() {
      await this.downloadLabelData(this.labelId);
      await this.setLockedLabel(this.labelId);
      await this.getLabelInfo(this.labelId);
    },
    uploadAndPreviewLabel() {
      this.$router.push(`/qa/labels/${this.labelId}/upload`);
    },
    openPreview(data) {
      this.currentPreview = data;
      this.showPreview = true;
    },
    async onPreview(version) {
      const versionId = version.labelVersionId;
      this.activePreview =
        version.labelVersionId != this.activePreview
          ? version.labelVersionId
          : 0;

      if (!version.previewData) {
        try {
          this.loading = true;
          await this.$store.dispatch("QUALITY_ASSURANCE/GET_PREVIEW", {
            labelId: this.labelId,
            versionId: versionId
          });
          this.versionData = [
            this.$store.getters["QUALITY_ASSURANCE/PREVIEW"]
          ].map(d => ({
            left: {
              variables: d.variables.leftVariables,
              preview: "data:image/png;base64, " + d.design.leftPng
            },
            right: {
              variables: d.variables.rightVariables,
              preview: "data:image/png;base64, " + d.design.rightPng
            }
          }));
          version.previewData = this.versionData;
          this.loading = false;
        } catch (error) {
          this.activePreview = 0;
        }
      } else {
        this.loading = false;
      }
    },
    onSearch(value) {
      this.searchQuery$.next(value);
    }
  },
  async mounted() {
    this.loading = true;

    this.searchQuery$ = new BehaviorSubject("");
    this.searchStream$$ = combineLatest([
      this.searchQuery$.pipe(distinctUntilChanged())
    ])
      .pipe(debounceTime(300))
      .subscribe(([searchQuery]) => {
        this.testArticleQuery = searchQuery;
        this.searchTestArticles(encodeURIComponent(searchQuery || ""));
      });
    await this.getData();
    this.loading = false;
  },
  beforeDestroy() {
    this.searchStream$$.unsubscribe();
  }
};
</script>
